

export const types = {



  RESET_PROFILE: "RESET_PROFILE",

  GET_USER_INFO_REQUEST: 'GET_USER_INFO_REQUEST',
  GET_USER_INFO_SUCCESS: 'GET_USER_INFO_SUCCESS',
  GET_USER_INFO_ERROR: 'GET_USER_INFO_ERROR',

  GET_ALL_ROLES_REQUEST: "GET_ALL_ROLES_REQUEST",
  GET_ALL_ROLES_SUCCESS: "GET_ALL_ROLES_SUCCESS",
  GET_ALL_ROLES_ERROR: "GET_ALL_ROLES_ERROR",

  PUSH_ACCESS_LIST: 'PUSH_ACCESS_LIST',
  EMPTY_ACCESS_LIST: 'EMPTY_ACCESS_LIST',


  NOTIICATION_COUNT_REQUEST: 'NOTIICATION_COUNT_REQUEST',
  NOTIICATION_COUNT_SUCCESS: 'NOTIICATION_COUNT_SUCCESS',
  NOTIICATION_COUNT_ERROR: 'NOTIICATION_COUNT_ERROR',
  NOTIICATION_COUNT_RESET_PROPS: 'NOTIICATION_COUNT_RESET_PROPS',

  RESET_SELECTED_IVR: 'RESET_SELECTED_IVR',
  SET_SELECTED_IVR: 'SET_SELECTED_IVR',


  RESET_IS_EXIST_EMAIL_PROPS: 'RESET_IS_EXIST_EMAIL_PROPS',









  GET_PROFILE_REQUEST: 'GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_ERROR: ' GET_PROFILE_ERROR',
  GET_PROFILE_RESET_PROPS: 'GET_PROFILE_RESET_PROPS',

  GET_NARRATOR: 'GET_NARRATOR',

  GET_ALL_MUSIC_ON_HOLD: 'GET_ALL_MUSIC_ON_HOLD',
  GET_ALL_MUSIC_ON_HOLD_SUCCESS: 'GET_ALL_MUSIC_ON_HOLD_SUCCESS',
  GET_ALL_MUSIC_ON_HOLD_ERROR: 'GET_ALL_MUSIC_ON_HOLD_ERROR',


  GET_IVR_SETTINGS_REQUEST: 'GET_IVR_SETTINGS_REQUEST',
  GET_IVR_SETTINGS_REQUEST_SUCCESS: 'GET_IVR_SETTINGS_REQUEST_SUCCESS',
  GET_IVR_SETTINGS_REQUEST_ERROR: 'GET_IVR_SETTINGS_REQUEST_ERROR',

  IVR_SETTING_SET_CALENDAR_FRIDAYS_STATE: 'IVR_SETTING_SET_CALENDAR_FRIDAYS_STATE',
  IVR_SETTING_SET_CALENDAR_HOLIDAY_STATE: 'IVR_SETTING_SET_CALENDAR_HOLIDAY_STATE',


  LOGIN_USER_REQUEST: 'LOGIN_USER_REQUEST',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  LOGIN_USER_ERROR: 'LOGIN_USER_ERROR',
  LOGIN_USER_RESET_PROPS: 'LOGIN_USER_RESET_PROPS',


  REGISTER_USER_REQUEST: 'REGISTER_USER_REQUEST',
  REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS',
  REGISTER_USER_ERROR: 'REGISTER_USER_ERROR',
  REGISTER_USER_RESET_PROPS: 'REGISTER_USER_RESET_PROPS',

  GET_CAREER_FIELD_REQUEST: 'GET_CAREER_FIELD_REQUEST',
  GET_CAREER_FIELD_SUCCESS: 'GET_CAREER_FIELD_SUCCESS',
  GET_CAREER_FIELD_ERROR: 'GET_CAREER_FIELD_ERROR',
  GET_CAREER_FIELD_RESET_PROPS: 'GET_CAREER_FIELD_RESET_PROPS',

  CHECK_EMAIL_EXIST_REQUEST: 'CHECK_EMAIL_EXIST_REQUEST',
  CHECK_EMAIL_EXIST_SUCCESS: 'CHECK_EMAIL_EXIST_SUCCESS',
  CHECK_EMAIL_EXIST_ERROR: 'CHECK_EMAIL_EXIST_ERROR',
  CHECK_EMAIL_EXIST_RESET_PROPS: 'CHECK_EMAIL_EXIST_RESET_PROPS',

  CAPTCHA_VERIFIED_REQUEST: 'CAPTCHA_VERIFIED_REQUEST',
  CAPTCHA_VERIFIED_SUCCESS: 'CAPTCHA_VERIFIED_SUCCESS',
  CAPTCHA_VERIFIED_ERROR: 'CAPTCHA_VERIFIED_ERROR',
  CAPTCHA_VERIFIED_RESET_PROPS: 'CAPTCHA_VERIFIED_RESET_PROPS',


  GET_AUDIO_LINK_REQUEST: 'GET_AUDIO_LINK_REQUEST',
  GET_AUDIO_LINK_REQUEST_SUCCESS: 'GET_AUDIO_LINK_REQUEST_SUCCESS',
  GET_AUDIO_LINK_REQUEST_ERROR: 'GET_AUDIO_LINK_REQUEST_ERROR',


  SAVE_IVR_SETTINGS_REQUEST: 'SAVE_IVR_SETTINGS_REQUEST',
  SAVE_IVR_SETTINGS_REQUEST_SUCCESS: 'SAVE_IVR_SETTINGS_REQUEST_SUCCESS',
  SAVE_IVR_SETTINGS_REQUEST_ERROR: 'SAVE_IVR_SETTINGS_REQUEST_ERROR',

  IVR_PROPS_RESET: 'IVR_PROPS_RESET',


  GET_INSTRUCTION_REQUEST: 'GET_INSTRUCTION_REQUEST',
  GET_INSTRUCTION_SUCCESS: 'GET_INSTRUCTION_SUCCESS',
  GET_INSTRUCTION_ERROR: 'GET_INSTRUCTION_ERROR',
  GET_INSTRUCTION_RESET_PROPS: 'GET_INSTRUCTION_RESET_PROPS',

  GET_CUSTOMER_MEMBER2_REQUEST: 'GET_CUSTOMER_MEMBER2_REQUEST',
  GET_CUSTOMER_NUMBER2_SUCCESS: 'GET_CUSTOMER_NUMBER2_SUCCESS',
  GET_CUSTOMER_NUMBER2_ERROR: 'GET_CUSTOMER_NUMBER2_ERROR',
  GET_CUSTOMER_NUMBER2_RESET_PROPS: 'GET_CUSTOMER_NUMBER2_RESET_PROPS',


  SAVE_INSTRUCTION_REQUEST: 'SAVE_INSTRUCTION_REQUEST',
  SAVE_INSTRUCTION_SUCCESS: 'SAVE_INSTRUCTION_SUCCESS',
  SAVE_INSTRUCTION_ERROR: 'SAVE_INSTRUCTION_ERROR',
  SAVE_INSTRUCTION_RESET_PROPS: 'SAVE_INSTRUCTION_RESET_PROPS',

  GET_CUSTOM_MEMBER_REQUEST: 'GET_CUSTOM_MEMBER_REQUEST',
  GET_CUSTOM_MEMBER_SUCCESS: 'GET_CUSTOM_MEMBER_SUCCESS',
  GET_CUSTOM_MEMBER_ERROR: 'GET_CUSTOM_MEMBER_ERROR',
  GET_CUSTOM_MEMBER_RESET_PROPS: 'GET_CUSTOM_MEMBER_RESET_PROPS',


  SEND_RESET_PASSWORD_EMAIL_REQUEST: 'SEND_RESET_PASSWORD_EMAIL_REQUEST',
  SEND_RESET_PASSWORD_EMAIL_SUCCESS: 'SEND_RESET_PASSWORD_EMAIL_SUCCESS',
  SEND_RESET_PASSWORD_EMAIL_ERROR: 'SEND_RESET_PASSWORD_EMAIL_ERROR',
  SEND_RESET_PASSWORD_EMAIL_RESET_PROPS: 'SEND_RESET_PASSWORD_EMAIL_RESET_PROPS',



  CALL_REPORT_REQUEST: 'CALL_REPORT_REQUEST',
  CALL_REPORT_SUCCESS: 'CALL_REPORT_SUCCESS',
  CALL_REPORT_ERROR: 'CALL_REPORT_ERROR',

  CALL_REPORT_CALL_DIRECT_REQUEST: "CALL_REPORT_CALL_DIRECT_REQUEST",
  CALL_REPORT_CALL_DIRECT_SUCCESS: 'CALL_REPORT__CALL_DIRECT_SUCCESS',
  CALL_REPORT_CALL_DIRECT_ERROR: 'CALL_REPORT__CALL_DIRECT_ERROR',


  GET_CONTACTS_REPORT_REQUEST: 'GET_CONTACTS_REPORT_REQUEST',
  GET_CONTACTS_REPORT_SUCCESS: 'GET_CONTACTS_REPORT_SUCCESS',
  GET_CONTACTS_REPORT_ERROR: 'GET_CONTACTS_REPORT_ERROR',




  GET_CUSTOMER_CALL_TYPES_REQUEST: 'GET_CUSTOMER_CALL_TYPES_REQUEST',
  GET_CUSTOMER_CALL_TYPES_SUCCESS: 'GET_CUSTOMER_CALL_TYPES_SUCCESS',
  GET_CUSTOMER_CALL_TYPES_ERROR: 'GET_CUSTOMER_CALL_TYPES_ERROR',


  CALL_REPORT_RESET_PROPS: 'CALL_REPORT_RESET_PROPS',

  PROFILE_RESEND_MOBILE_VERIFICATION_CODE_REQUEST: 'PROFILE_RESEND_MOBILE_VERIFICATION_CODE_REQUEST',
  PROFILE_RESEND_MOBILE_VERIFICATION_CODE_SUCCESS: 'PROFILE_RESEND_MOBILE_VERIFICATION_CODE_SUCCESS',
  PROFILE_RESEND_MOBILE_VERIFICATION_CODE_ERROR: 'PROFILE_RESEND_MOBILE_VERIFICATION_CODE_ERROR',
  PROFILE_RESEND_MOBILE_VERIFICATION_CODE_RESET_PROPS: 'PROFILE_RESEND_MOBILE_VERIFICATION_CODE_RESET_PROPS',


  PROFILE_VERIFY_MOBILE_REQUEST: 'PROFILE_VERIFY_MOBILE_REQUEST',
  PROFILE_VERIFY_MOBILE_SUCCESS: 'PROFILE_VERIFY_MOBILE_SUCCESS',
  PROFILE_VERIFY_MOBILE_ERROR: 'PROFILE_VERIFY_MOBILE_ERROR',
  PROFILE_VERIFY_MOBILE_RESET_PROPS: 'PROFILE_VERIFY_MOBILE_RESET_PROPS',


  PROFILE_GET_PROVINCE_WITH_CITY_REQUEST: 'PROFILE_GET_PROVINCE_WITH_CITY_REQUEST',
  PROFILE_GET_PROVINCE_WITH_CITY_SUCCESS: 'PROFILE_GET_PROVINCE_WITH_CITY_SUCCESS',
  PROFILE_GET_PROVINCE_WITH_CITY_ERROR: 'PROFILE_GET_PROVINCE_WITH_CITY_ERROR',
  PROFILE_GET_PROVINCE_WITH_CITY_RESET_PROPS: 'PROFILE_GET_PROVINCE_WITH_CITY_RESET_PROPS',

  PROFILE_SAVE_REQUEST: 'PROFILE_SAVE_REQUEST',
  PROFILE_SAVE_SUCCESS: 'PROFILE_SAVE_SUCCESS',
  PROFILE_SAVE_ERROR: 'PROFILE_SAVE_ERROR',
  PROFILE_SAVE_RESET_PROPS: 'PROFILE_SAVE_RESET_PROPS',


  RESEND_EMAIL_VERIFICATION_REQUEST: 'RESEND_EMAIL_VERIFICATION_REQUEST',
  RESEND_EMAIL_VERIFICATION_SUCCESS: 'RESEND_EMAIL_VERIFICATION_SUCCESS',
  RESEND_EMAIL_VERIFICATION_ERROR: 'RESEND_EMAIL_VERIFICATION_ERROR',
  RESEND_EMAIL_VERIFICATION_RESET_PROPS: 'RESEND_EMAIL_VERIFICATION_RESET_PROPS',

  CHANGE_EMAIL_VERIFICATION_REQUEST: "CHANGE_EMAIL_VERIFICATION_REQUEST",
  CHANGE_EMAIL_VERIFICATION_SUCCESS: "CHANGE_EMAIL_VERIFICATION_SUCCESS",
  CHANGE_EMAIL_VERIFICATION_ERROR: "CHANGE_EMAIL_VERIFICATION_ERROR",


  PROFILE_CHANGE_PASSWORD_REQUEST: 'PROFILE_CHANGE_PASSWORD_REQUEST',
  PROFILE_CHANGE_PASSWORD_SUCCESS: 'PROFILE_CHANGE_PASSWORD_SUCCESS',
  PROFILE_CHANGE_PASSWORD_ERROR: 'PROFILE_CHANGE_PASSWORD_ERROR',
  PROFILE_CHANGE_PASSWORD_RESET_PROPS: 'PROFILE_CHANGE_PASSWORD_RESET_PROPS',

  PROFILE_GET_DOCUMEN_REQUEST: 'PROFILE_GET_DOCUMEN_REQUEST',
  PROFILE_GET_DOCUMEN_SUCCESS: 'PROFILE_GET_DOCUMEN_SUCCESS',
  PROFILE_GET_DOCUMEN_ERROR: 'PROFILE_GET_DOCUMEN_ERROR',
  PROFILE_GET_DOCUMEN_RESET_PROPS: 'PROFILE_GET_DOCUMEN_RESET_PROPS',

  PROFILE_SAVE_DOCUMEN_REQUEST: 'PROFILE_SAVE_DOCUMEN_REQUEST',
  PROFILE_SAVE_DOCUMEN_SUCCESS: 'PROFILE_SAVE_DOCUMEN_SUCCESS',
  PROFILE_SAVE_DOCUMEN_ERROR: 'PROFILE_SAVE_DOCUMEN_ERROR',
  PROFILE_SAVE_DOCUMEN_RESET_PROPS: 'PROFILE_SAVE_DOCUMEN_RESET_PROPS',

  PROFILE_DELETE_BY_ID_DOCUMENT_REQUEST: 'PROFILE_DELETE_BY_ID_DOCUMEN_REQUEST',
  PROFILE_DELETE_BY_ID_DOCUMENT_SUCCESS: 'PROFILE_DELETE_BY_ID_DOCUMEN_SUCCESS',
  PROFILE_DELETE_BY_ID_DOCUMENT_ERROR: 'PROFILE_DELETE_BY_ID_DOCUMEN_ERROR',

  PROFILE_DELETE_DOCUMENT_REQUEST: 'PROFILE_DELETE_DOCUMENT_REQUEST',
  PROFILE_DELETE_DOCUMENT_SUCCESS: 'PROFILE_DELETE_DOCUMENT_SUCCESS',
  PROFILE_DELETE_DOCUMENT_ERROR: 'PROFILE_DELETE_DOCUMENT_ERROR',


  PROFILE_DELETE_DOCUMEN_RESET_PROPS: 'PROFILE_DELETE_DOCUMEN_RESET_PROPS',

  PUSH_RETURN_TO_OLD_ID: 'PUSH_RETURN_TO_OLD_ID',

  GET_GENERAL_LINE_SETTINGS_REQUEST: 'GET_GENERAL_LINE_SETTINGS_REQUEST',
  GET_GENERAL_LINE_SETTINGS_SUCCESS: 'GET_GENERAL_LINE_SETTINGS_SUCCESS',
  GET_GENERAL_LINE_SETTINGS_ERROR: 'GET_GENERAL_LINE_SETTINGS_ERROR',

  SET_GENERAL_LINE_SETTINGS_REQUEST: 'SET_GENERAL_LINE_SETTINGS_REQUEST',
  SET_GENERAL_LINE_SETTINGS_SUCCESS: 'SET_GENERAL_LINE_SETTINGS_SUCCESS',
  SET_GENERAL_LINE_SETTINGS_ERROR: 'SET_GENERAL_LINE_SETTINGS_ERROR',

  GET_CUSTOMER_LINE_SERVICES_REQUEST: 'GET_CUSTOMER_LINE_SERVICES_REQUEST',
  GET_CUSTOMER_LINE_SERVICES_SUCCESS: 'GET_CUSTOMER_LINE_SERVICES_SUCCESS',
  GET_CUSTOMER_LINE_SERVICES_ERROR: 'GET_CUSTOMER_LINE_SERVICES_ERROR',

  GET_CALL_REPORT_SETTINGS_REQUEST: 'GET_CALL_REPORT_SETTINGS_REQUEST',
  GET_CALL_REPORT_SETTINGS_SUCCESS: 'GET_CALL_REPORT_SETTINGS_SUCCESS',
  GET_CALL_REPORT_SETTINGS_ERROR: 'GET_CALL_REPORT_SETTINGS_ERROR',

  SET_CALL_REPORT_SETTINGS_REQUEST: 'SET_CALL_REPORT_SETTINGS_REQUEST',
  SET_CALL_REPORT_SETTINGS_SUCCESS: 'SET_CALL_REPORT_SETTINGS_SUCCESS',
  SET_CALL_REPORT_SETTINGS_ERROR: 'SET_CALL_REPORT_SETTINGS_ERROR',

  GET_LINE_FAX_SETTINGS_REQUEST: 'GET_LINE_FAX_SETTINGS_REQUEST',
  GET_LINE_FAX_SETTINGS_SUCCESS: 'GET_LINE_FAX_SETTINGS_SUCCESS',
  GET_LINE_FAX_SETTINGS_ERROR: 'GET_LINE_FAX_SETTINGS_ERROR',

  SET_LINE_FAX_SETTINGS_REQUEST: 'SET_LINE_FAX_SETTINGS_REQUEST',
  SET_LINE_FAX_SETTINGS_SUCCESS: 'SET_LINE_FAX_SETTINGS_SUCCESS',
  SET_LINE_FAX_SETTINGS_ERROR: 'SET_LINE_FAX_SETTINGS_ERROR',


  GET_LINE_VOICEMAIL_SETTINGS_REQUEST: 'GET_LINE_VOICEMAIL_SETTINGS_REQUEST',
  GET_LINE_VOICEMAIL_SETTINGS_SUCCESS: 'GET_LINE_VOICEMAIL_SETTINGS_SUCCESS',
  GET_LINE_VOICEMAIL_SETTINGS_ERROR: 'GET_LINE_VOICEMAIL_SETTINGS_ERROR',

  SET_LINE_VOICEMAIL_SETTINGS_REQUEST: 'SET_LINE_VOICEMAIL_SETTINGS_REQUEST',
  SET_LINE_VOICEMAIL_SETTINGS_SUCCESS: 'SET_LINE_VOICEMAIL_SETTINGS_SUCCESS',
  SET_LINE_VOICEMAIL_SETTINGS_ERROR: 'SET_LINE_VOICEMAIL_SETTINGS_ERROR',

  GET_CUSTOMER_MEMBERS_REQUEST: 'GET_CUSTOMER_MEMBERS_REQUEST',
  GET_CUSTOMER_MEMBERS_SUCCESS: 'GET_CUSTOMER_MEMBERS_SUCCESS',
  GET_CUSTOMER_MEMBERS_ERROR: 'GET_CUSTOMER_MEMBERS_ERROR',
  RESET_GET_CUSTOMER_MEMBERS_ERROR: 'RESET_GET_CUSTOMER_MEMBERS_ERROR',
  SET_SELECTED_COUSTOMER: 'SET_SELECTED_COUSTOMER',
  RESET_SELECTED_CUSTOMER: 'RESET_SELECTED_CUSTOMER',


  GET_PASSWORD_STATUS_REQUEST: 'GET_PASSWORD_STATUS_REQUEST',
  GET_PASSWORD_STATUS_SUCCESS: 'GET_PASSWORD_STATUS_SUCCESS',
  GET_PASSWORD_STATUS_ERROR: 'GET_PASSWORD_STATUS_ERROR',

  SET_PASSWORD_STATUS_REQUEST: 'SET_PASSWORD_STATUS_REQUEST',
  SET_PASSWORD_STATUS_SUCCESS: 'SET_PASSWORD_STATUS_SUCCESS',
  SET_PASSWORD_STATUS_ERROR: 'SET_PASSWORD_STATUS_ERROR',

  SET_PASSWORD_SETTING_REQUEST: 'SET_PASSWORD_SETTING_REQUEST',
  SET_PASSWORD_SETTING_SUCCESS: 'SET_PASSWORD_SETTING_SUCCESS',
  SET_PASSWORD_SETTING_ERROR: 'SET_PASSWORD_SETTING_ERROR',


  GET_CALL_REPORT_TO_EXPORT_REQUEST: 'GET_CALL_REPORT_TO_EXPORT_REQUEST',
  GET_CALL_REPORT_TO_EXPORT_SUCCESS: 'GET_CALL_REPORT_TO_EXPORT_SUCCESS',
  GET_CALL_REPORT_TO_EXPORT_ERROR: 'GET_CALL_REPORT_TO_EXPORT_ERROR',


  GET_CALL_REPORT_FILE_REQUEST: 'GET_CALL_REPORT_FILE_REQUEST',
  GET_CALL_REPORT_FILE_SUCCESS: 'GET_CALL_REPORT_FILE_SUCCESS',
  GET_CALL_REPORT_FILE_ERROR: 'GET_CALL_REPORT_FILE_ERROR',

  COMPANY_INFO_SAVE_REQUEST: 'COMPANY_INFO_SAVE_REQUEST',
  COMPANY_INFO_SAVE_SUCCESS: 'COMPANY_INFO_SAVE_SUCCESS',
  COMPANY_INFO_SAVE_ERROR: 'COMPANY_INFO_SAVE_ERROR',

  GET_COMPANY_INFO_REQUEST: 'GET_COMPANY_INFO_REQUEST',
  GET_COMPANY_INFO_SUCCESS: 'GET_COMPANY_INFO_SUCCESS',
  GET_COMPANY_INFO_ERROR: 'GET_COMPANY_INFO_ERROR',



  GET_ALL_PAIED_INVOICE_REQUEST: 'GET_ALL_PAIED_INVOICE_REQUEST',
  GET_ALL_PAIED_INVOICE_SUCCESS: 'GET_ALL_PAIED_INVOICE_SUCCESS',
  GET_ALL_PAIED_INVOICE_ERROR: 'GET_ALL_PAIED_INVOICE_ERROR',

  GET_INVOCE_IN_PORTAL_REQUEST: 'GET_INVOCE_IN_PORTAL_REQUEST',
  GET_INVOCE_IN_PORTAL_SUCCESS: 'GET_INVOCE_IN_PORTAL_SUCCESS',
  GET_INVOCE_IN_PORTAL_ERROR: 'GET_INVOCE_IN_PORTAL_ERROR',

  SET_ISSUTYPE_INVOICE_REQUEST: 'SET_ISSUTYPE_INVOICE_REQUEST',
  SET_ISSUTYPE_INVOICE_SUCCESS: 'SET_ISSUTYPE_INVOICE_SUCCESS',
  SET_ISSUTYPE_INVOICE_ERROR: 'SET_ISSUTYPE_INVOICE_ERROR',

  TRANSACTION_RESET_PROPS: 'TRANSACTION_RESET_PROPS',

  COMPANY_INFO_RESET_PROPS: 'COMPANY_INFO_RESET_PROPS',

  COMPANY_RESET_PROPS: "COMPANY_RESET_PROPS",

  GET_LINE_SEPARATION_SETTING_REQUEST: 'GET_LINE_SEPARATION_SETTING_REQUEST',
  GET_LINE_SEPARATION_SETTING_SUCCESS: 'GET_LINE_SEPARATION_SETTING_SUCCESS',
  GET_LINE_SEPARATION_SETTING_ERROR: 'GET_LINE_SEPARATION_SETTING_ERROR',


  GET_S3URL_REQUEST: 'GET_S3URL_REQUEST',
  GET_S3URL_SUCCESS: 'GET_S3URL_SUCCESS',
  GET_S3URL_ERROR: 'GET_S3URL_ERROR',


  GET_BANK_GATEWAYS_REQUEST: 'GET_BANK_GATEWAYS_REQUEST',
  GET_BANK_GATEWAYS_SUCCESS: 'GET_BANK_GATEWAYS_SUCCESS',
  GET_BANK_GATEWAYS_ERROR: 'GET_BANK_GATEWAYS_ERROR',

  GET_MINIMUM_CHARGE_AMOUNT_REQUEST: 'GET_MINIMUM_CHARGE_AMOUNT_REQUEST',
  GET_MINIMUM_CHARGE_AMOUNT_SUCCESS: 'GET_MINIMUM_CHARGE_AMOUNT_SUCCESS',
  GET_MINIMUM_CHARGE_AMOUNT_ERROR: 'GET_MINIMUM_CHARGE_AMOUNT_ERROR',

  GET_VAT_PERCENT_REQUEST: 'GET_VAT_PERCENT_REQUEST',
  GET_VAT_PERCENT_SUCCESS: 'GET_VAT_PERCENT_SUCCESS',
  GET_VAT_PERCENT_ERROR: 'GET_VAT_PERCENT_ERROR',

  POST_MAKE_CHARGE_REQUEST: 'POST_MAKE_CHARGE_REQUEST',
  POST_MAKE_CHARGE_SUCCESS: 'POST_MAKE_CHARGE_SUCCESS',
  POST_MAKE_CHARGE_ERROR: 'POST_MAKE_CHARGE_ERROR',


  GET_CURRENT_CHARGE_AMOUNT_REQUEST: 'GET_CURRENT_CHARGE_AMOUNT_REQUEST',
  GET_CURRENT_CHARGE_AMOUNT_SUCCESS: 'GET_CURRENT_CHARGE_AMOUNT_SUCCESS',
  GET_CURRENT_CHARGE_AMOUNT_ERROR: 'GET_CURRENT_CHARGE_AMOUNT_ERROR',

  PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_REQUEST: 'PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_REQUEST',
  PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_SUCCESS: 'PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_SUCCESS',
  PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_ERROR: 'PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_ERROR',

  GET_GTM_PURCHASE_INFO_REQUEST: 'GET_GTM_PURCHASE_INFO_REQUEST',
  GET_GTM_PURCHASE_INFO_SUCCESS: 'GET_GTM_PURCHASE_INFO_SUCCESS',
  GET_GTM_PURCHASE_INFO_ERROR: 'GET_GTM_PURCHASE_INFO_ERROR',

  SET_LINE_SERVICE_TYPE: 'SET_LINE_SERVICE_TYPE',
  CHARGE_PROPS_RESET: 'CHARGE_PROPS_RESET',
  COMMON_PROPS_RESET: 'COMMON_PROPS_RESET',


  LINE_SETTINGS_RESET_PROPS: 'LINE_SETTINGS_RESET_PROPS',
  S3URL_RESET_PROPS: 'S3URL_RESET_PROPS',


  SELECT_PACKAGE_REQUEST: 'SELECT_PACKAGE_REQUEST',
  SELECT_PACKAGE_SUCCESS: 'SELECT_PACKAGE_SUCCESS',
  SELECT_PACKAGE_ERROR: 'SELECT_PACKAGE_ERROR',


  UPLOAD_REQUEST: 'UPLOAD_REQUEST',
  UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
  UPLOAD_ERROR: 'UPLOAD_ERROR',



  GET_ALL_COMPANY_REQUEST: 'GET_ALL_COMPANY_REQUEST',
  GET_ALL_COMPONY_ERROR: 'GET_ALL_COMPONY_ERROR',
  GET_ALL_COMPONY_SUCCESS: 'GET_ALL_COMPONY_SUCCESS',
  ADD_NEW_EMAIL_REQUEST: "ADD_NEW_EMAIL_REQUEST",
  ADD_NEW_EMAIL_SUCCESS: "ADD_NEW_EMAIL_SUCCESS",
  ADD_NEW_EMAIL_ERROR: "ADD_NEW_EMAIL_ERROR",


  REJECT_NEW_EMAIL_REQUEST: "REJECT_NEW_EMAIL_REQUEST",
  REJECT_NEW_EMAIL_SUCCESS: "REJECT_NEW_EMAIL_SUCCESS",
  REJECT_NEW_EMAIL_ERROR: "REJECT_NEW_EMAIL_ERROR",


  POST_UPLOAD_MUSIC_ON_HOLD_REQUEST: "POST_UPLOAD_MUSIC_ON_HOLD_REQUEST",
  POST_UPLOAD_MUSIC_ON_HOLD_SUCCESS: "POST_UPLOAD_MUSIC_ON_HOLD_SUCCESS",
  POST_UPLOAD_MUSIC_ON_HOLD_ERROR: "POST_UPLOAD_MUSIC_ON_HOLD_ERROR",

  RESET_VOICE_MAIL_LINE_SETTINGS: "RESET_VOICE_MAIL_LINE_SETTINGS"


}


export enum Types {


  GET_CONTACT_CALL_DIRECT_ERROR = "GET_CONTACT_CALL_DIRECT_ERROR",
  GET_CONTACT_CALL_DIRECT_SUCCESS = "GET_CONTACT_CALL_DIRECT_SUCCESS",
  GET_CONTACT_CALL_DIRECT_REQUEST = "GET_CONTACT_CALL_DIRECT_REQUEST",
  GET_CONTACT_CALL_DIRECT_RESET = "GET_CONTACT_CALL_DIRECT_RESET",



  GET_DASHBOARD_DATA_REQUEST = 'GET_DASHBOARD_DATA_REQUEST',
  GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS',
  GET_DASHBOARD_DATA_ERROR = 'GET_DASHBOARD_DATA_ERROR',
  GET_DASHBOARD_DATA_RESET_PROPS = 'GET_DASHBOARD_DATA_RESET_PROPS',

  GET_FAX_INFO_SERVICE_REQUEST = 'GET_FAX_INFO_SERVICE_REQUEST',
  GET_FAX_INFO_SERVICE_SUCCESS = 'GET_FAX_INFO_SERVICE_SUCCESS',
  GET_FAX_INFO_SERVICE_ERROR = 'GET_FAX_INFO_SERVICE_ERROR',
  GET_FAX_INFO_RESET_PROPS = 'GET_FAX_INFO_RESET_PROPS',

  GET_IVR_INFO_SERVICE_REQUEST = 'GET_IVR_INFO_SERVICE_REQUEST',
  GET_IVR_INFO_SERVICE_SUCCESS = 'GET_IVR_INFO_SERVICE_SUCCESS',
  GET_IVR_INFO_SERVICE_ERROR = 'GET_IVR_INFO_SERVICE_ERROR',
  IVR_INFO_SERVICE_RESET_PROPS = '  IVR_INFO_SERVICE_RESET_PROPS',

  GET_SECRETARY_INFO_SERVICE_REQUEST = 'GET_SECRETARY_INFO_SERVICE_REQUEST',
  GET_SECRETARY_INFO_SERVICE_SUCCESS = 'GET_SECRETARY_INFO_SERVICE_SUCCESS',
  GET_SECRETARY_INFO_SERVICE_ERROR = 'GET_SECRETARY_INFO_SERVICE_ERROR',
  SECRETARY_INFO_SERVICE_RESET_PROPS = 'SECRETARY_INFO_SERVICE_RESET_PROPS',



  GET_LATEST_CUSTOMER_REQUEST = 'GET_LATEST_CUSTOMER_REQUEST',
  GET_LATEST_CUSTOMER_SUCCESS = 'GET_LATEST_CUSTOMER_SUCCESS',
  GET_LATEST_CUSTOMER_ERROR = 'GET_LATEST_CUSTOMER_ERROR',

  RESET_TICKET_REGISTER = 'RESET_TICKET_REGISTER',

  // GET_DASHBOARD_DATA_REQUEST= 'GET_DASHBOARD_DATA_REQUEST',
  // GET_DASHBOARD_DATA_SUCCESS= 'GET_DASHBOARD_DATA_SUCCESS',
  // GET_DASHBOARD_DATA_ERROR= 'GET_DASHBOARD_DATA_ERROR',
  // GET_DASHBOARD_DATA_RESET_PROPS='GET_DASHBOARD_DATA_RESET_PROPS',

  // GET_FAX_INFO_SERVICE_REQUEST= 'GET_FAX_INFO_SERVICE_REQUEST',
  // GET_FAX_INFO_SERVICE_SUCCESS= 'GET_FAX_INFO_SERVICE_SUCCESS',
  // GET_FAX_INFO_SERVICE_ERROR= 'GET_FAX_INFO_SERVICE_ERROR',
  // GET_FAX_INFO_RESET_PROPS= 'GET_FAX_INFO_RESET_PROPS',

  // GET_IVR_INFO_SERVICE_REQUEST='GET_IVR_INFO_SERVICE_REQUEST',
  // GET_IVR_INFO_SERVICE_SUCCESS= 'GET_IVR_INFO_SERVICE_SUCCESS',
  // GET_IVR_INFO_SERVICE_ERROR= 'GET_IVR_INFO_SERVICE_ERROR',
  // IVR_INFO_SERVICE_RESET_PROPS= '  IVR_INFO_SERVICE_RESET_PROPS',

  // GET_SECRETARY_INFO_SERVICE_REQUEST= 'GET_SECRETARY_INFO_SERVICE_REQUEST',
  // GET_SECRETARY_INFO_SERVICE_SUCCESS= 'GET_SECRETARY_INFO_SERVICE_SUCCESS',
  // GET_SECRETARY_INFO_SERVICE_ERROR= 'GET_SECRETARY_INFO_SERVICE_ERROR',
  // SECRETARY_INFO_SERVICE_RESET_PROPS= 'SECRETARY_INFO_SERVICE_RESET_PROPS',

  GET_CREDIT_DETAILS_REQUEST = 'GET_CREDIT_DETAILS_REQUEST',
  GET_CREDIT_DETAILS_SUCCESS = 'GET_CREDIT_DETAILS_SUCCESS',
  GET_CREDIT_DETAILS_ERROR = 'GET_CREDIT_DETAILS_ERROR',

  GET_FULL_NAME_REQUEST = 'GET_FULL_NAME_REQUEST',
  GET_FULL_NAME_SUCCESS = 'GET_FULL_NAME_SUCCESS',
  GET_FULL_NAME_ERROR = 'GET_FULL_NAME_ERROR',

  REPLY_TICKET_REQUEST = 'REPLY_TICKET_REQUEST',
  REPLY_TICKET_SUCCESS = 'REPLY_TICKET_SUCCESS',
  REPLY_TICKET_ERROR = 'REPLY_TICKET_ERROR',

  GET_TICKET_BY_USER_ID_TICKET_REQUEST = 'GET_TICKET_BY_USER_ID_TICKET_REQUEST',
  GET_TICKET_BY_USER_ID_TICKET_SUCCESS = 'GET_TICKET_BY_USER_ID_TICKET_SUCCESS',
  GET_TICKET_BY_USER_ID_TICKET_ERROR = 'GET_TICKET_BY_USER_ID_TICKET_ERROR',

  REGISTER_TICKET_REQUEST = 'REGISTER_TICKET_REQUEST',
  REGISTER_TICKET_SUCCESS = 'REGISTER_TICKET_SUCCESS',
  REGISTER_TICKET_ERROR = 'REGISTER_TICKET_ERROR',

  GET_VIEW_TICKET_REQUEST = 'GET_VIEW_TICKET_REQUEST',
  GET_VIEW_TICKET_SUCCESS = 'GET_VIEW_TICKET_SUCCESS',
  GET_VIEW_TICKET_ERROR = 'GET_VIEW_TICKET_ERROR',

  GET_TICKET_BY_USER_REQUEST = 'GET_TICKET_BY_USER_REQUEST',
  GET_TICKET_BY_USER_SUCCESS = 'GET_TICKET_BY_USER_SUCCESS',
  GET_TICKET_BY_USER_ERROR = 'GET_TICKET_BY_USER_ERROR',



  SELECT_PACKAGE_REQUEST = 'SELECT_PACKAGE_REQUEST',
  SELECT_PACKAGE_SUCCESS = 'SELECT_PACKAGE_SUCCESS',
  SELECT_PACKAGE_ERROR = 'SELECT_PACKAGE_ERROR',


  GET_CANDIDATE_IVR_PRODUCT_REQUEST = 'GET_CANDIDATE_IVR_PRODUCT_REQUEST',
  GET_CANDIDATE_IVR_PRODUCT_SUCCESS = 'GET_CANDIDATE_IVR_PRODUCT_SUCCESS',
  GET_CANDIDATE_IVR_PRODUCT_ERROR = 'GET_CANDIDATE_IVR_PRODUCT_ERROR',


  GET_CANDIDATE_SECRETARY_PRODUCT_REQUEST = 'GET_CANDIDATE_SECRETARY_PRODUCT_REQUEST',
  GET_CANDIDATE_SECRETARY_PRODUCT_SUCCESS = 'GET_CANDIDATE_SECRETARY_PRODUCT_SUCCESS',
  GET_CANDIDATE_SECRETARY_PRODUCT_ERROR = 'GET_CANDIDATE_SECRETARY_PRODUCT_ERROR',

  GET_CANDIDATE_FAX_PRODUCT_REQUEST = 'GET_CANDIDATE_FAX_PRODUCT_REQUEST',
  GET_CANDIDATE_FAX_PRODUCT_SUCCESS = 'GET_CANDIDATE_FAX_PRODUCT_SUCCESS',
  GET_CANDIDATE_FAX_PRODUCT_ERROR = 'GET_CANDIDATE_FAX_PRODUCT_ERROR',


  GET_PRODUCT_NUMBERS_COUNT_REQUEST = 'GET_PRODUCT_NUMBERS_COUNT_REQUEST',
  GET_PRODUCT_NUMBERS_COUNT_SUCCESS = 'GET_PRODUCT_NUMBERS_COUNT_SUCCESS',
  GET_PRODUCT_NUMBERS_COUNT_ERROR = 'GET_PRODUCT_NUMBERS_COUNT_ERROR',


  GET_APPLICATION_CONTRACT_TYPE_REQUEST = 'GET_APPLICATION_CONTRACT_TYPE_REQUEST',
  GET_APPLICATION_CONTRACT_TYPE_SUCCESS = 'GET_APPLICATION_CONTRACT_TYPE_SUCCESS',
  GET_APPLICATION_CONTRACT_TYPE_ERROR = 'GET_APPLICATION_CONTRACT_TYPE_ERROR',


  GEN_HTML_PRE_INVOICE_TO_CUSTOMER_REQUEST = 'GEN_HTML_PRE_INVOICE_TO_CUSTOMER_REQUEST',
  GEN_HTML_PRE_INVOICE_TO_CUSTOMER_SUCCESS = 'GEN_HTML_PRE_INVOICE_TO_CUSTOMER_SUCCESS',
  GEN_HTML_PRE_INVOICE_TO_CUSTOMER_ERROR = 'GEN_HTML_PRE_INVOICE_TO_CUSTOMER_ERROR',


  SEARCH_FREE_PROPOSE_NUMBER_REQUEST = 'SEARCH_FREE_PROPOSE_NUMBER_REQUEST',
  SEARCH_FREE_PROPOSE_NUMBER_SUCCESS = 'SEARCH_FREE_PROPOSE_NUMBER_SUCCESS',
  SEARCH_FREE_PROPOSE_NUMBER_ERROR = 'SEARCH_FREE_PROPOSE_NUMBER_ERROR',


  GET_PREPARE_FOR_GATEWAY_REQUEST = 'GET_PREPARE_FOR_GATEWAY_REQUEST',
  GET_PREPARE_FOR_GATEWAY_SUCCESS = 'GET_PREPARE_FOR_GATEWAY_SUCCESS',
  GET_PREPARE_FOR_GATEWAY_ERROR = 'GET_PREPARE_FOR_GATEWAY_ERROR',


  POST_TRY_RESERVE_LINE_REQUEST = 'POST_TRY_RESERVE_LINE_REQUEST',
  POST_TRY_RESERVE_LINE_SUCCESS = 'POST_TRY_RESERVE_LINE_SUCCESS',
  POST_TRY_RESERVE_LINE_ERROR = 'POST_TRY_RESERVE_LINE_ERROR',


  POST_PURCHASE_BUY_REQUEST = 'POST_PURCHASE_BUY_REQUEST',
  POST_PURCHASE_BUY_SUCCESS = 'POST_PURCHASE_BUY_SUCCESS',
  POST_PURCHASE_BUY_ERROR = 'POST_PURCHASE_BUY_ERROR',


  GET_PURCHASE_INFO_REQUEST = 'GET_PURCHASE_INFO_REQUEST',
  GET_PURCHASE_INFO_SUCCESS = 'GET_PURCHASE_INFO_SUCCESS',
  GET_PURCHASE_INFO_ERROR = 'GET_PURCHASE_INFO_ERROR',


  GET_CITIES_REQUEST = 'GET_CITIES_REQUEST',
  GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS',
  GET_CITIES_ERROR = 'GET_CITIES_ERROR',


  GET_PROPOSED_NUMBERS_REQUEST = 'GET_PROPOSED_NUMBERS_REQUEST',
  GET_PROPOSED_NUMBERS_SUCCESS = 'GET_PROPOSED_NUMBERS_SUCCESS',
  GET_PROPOSED_NUMBERS_ERROR = 'GET_PROPOSED_NUMBERS_ERROR',

  SEARCH_PROPOSED_NUMBERS_REQUEST = 'SEARCH_PROPOSED_NUMBERS_REQUEST',
  SEARCH_PROPOSED_NUMBERS_SUCCESS = 'SEARCH_PROPOSED_NUMBERS_SUCCESS',
  SEARCH_PROPOSED_NUMBERS_ERROR = 'SEARCH_PROPOSED_NUMBERS_ERROR',


  SET_RESET_PURCHASE_PROPS = 'SET_RESET_PURCHASE_PROPS',

  INSERT_CALL_QUEUE_REQUEST = 'INSERT_CALL_QUEUE_REQUEST',
  INSERT_CALL_QUEUE_SUCCESS = 'INSERT_CALL_QUEUE_SUCCESS',
  INSERT_CALL_QUEUE_ERROR = 'INSERT_CALL_QUEUE_ERROR',

  UPDATE_QUEUE_REQUEST = 'UPDATE_QUEUE_REQUEST',
  UPDATE_QUEUE_SUCCESS = 'UPDATE_QUEUE_SUCCESS',
  UPDATE_QUEUE_ERROR = 'UPDATE_QUEUE_ERROR',

  GET_QUEUE_REQUEST = 'GET_QUEUE_REQUEST',
  GET_QUEUE_SUCCESS = 'GET_QUEUE_SUCCESS',
  GET_QUEUE_ERROR = 'GET_QUEUE_ERROR',

  DELETE_QUEUE_REQUEST = 'DELETE_QUEUE_REQUEST',
  DELETE_QUEUE_SUCCESS = 'DELETE_QUEUE_SUCCESS',
  DELETE_QUEUE_ERROR = 'DELETE_QUEUE_ERROR',



  UPLOAD_DEFAULT_MUSIC_REQUEST = "UPLOAD_DEFAULT_MUSIC_REQUEST",
  UPLOAD_DEFAULT_MUSIC_SUCCESS = "UPLOAD_DEFAULT_MUSIC_SUCCESS",
  UPLOAD_DEFAULT_MUSIC_ERROR = "UPLOAD_DEFAULT_MUSIC_ERROR",

  SAVE_ATTACHMENT_REQUEST = "SAVE_ATTACHMENT_REQUEST",
  SAVE_ATTACHMENT_SUCCESS = "SAVE_ATTACHMENT_SUCCESS",
  SAVE_ATTACHMENT_ERROR = "SAVE_ATTACHMENT_ERROR",

  GET_ATTACHMENT_REQUEST = "GET_ATTACHMENT_REQUEST",
  GET_ATTACHMENT_SUCCESS = "GET_ATTACHMENT_SUCCESS",
  GET_ATTACHMENT_ERROR = "GET_ATTACHMENT_ERROR",

  GET_ATTACHMENT_BY_ID_REQUEST = "GET_ATTACHMENT_BY_ID__REQUEST",
  GET_ATTACHMENT_BY_ID_SUCCESS = "GET_ATTACHMENT_BY_ID__SUCCESS",
  GET_ATTACHMENT_BY_ID_ERROR = "GET_ATTACHMENT_BY_ID__ERROR",

  DELETE_ATTACHMENT_REQUEST = "DELETE_ATTACHMENT_REQUEST",
  DELETE_ATTACHMENT_SUCCESS = "DELETE_ATTACHMENT_SUCCESS",
  DELETE_ATTACHMENT_ERROR = "DELETE_ATTACHMENT_ERROR",

  SET_RESET_ATTACHMENT_PROPS = "SET_RESET_ATTACHMENT_PROPS",


  SECRETARY_MESSAGE_SEARCH_REQUEST = "SECRETARY_MESSAGE_SEARCH_REQUEST",
  SECRETARY_MESSAGE_SEARCH_SUCCESS = "SECRETARY_MESSAGE_SEARCH_SUCCESS",
  SECRETARY_MESSAGE_SEARCH_ERROR = "SECRETARY_MESSAGE_SEARCH_ERROR",

  SECRETARY_MESSAGE_UPDATE_STAR_REQUEST = "SECRETARY_MESSAGE_UPDATE_STAR_REQUEST",
  SECRETARY_MESSAGE_UPDATE_STAR_SUCCESS = "SECRETARY_MESSAGE_UPDATE_STAR_SUCCESS",
  SECRETARY_MESSAGE_UPDATE_STAR_ERROR = "SECRETARY_MESSAGE_UPDATE_STAR_ERROR",


  SECRETARY_MESSAGE_SAVE_REQUEST = "SECRETARY_MESSAGE_SAVE_REQUEST",
  SECRETARY_MESSAGE_SAVE_SUCCESS = "SECRETARY_MESSAGE_SAVE_SUCCESS",
  SECRETARY_MESSAGE_SAVE_ERROR = "SECRETARY_MESSAGE_SAVE_ERROR",

  SECRETARY_MESSAGE_GET_NOTE_REQUEST = "SECRETARY_MESSAGE_GET_NOTE_REQUEST",
  SECRETARY_MESSAGE_GET_NOTE_SUCCESS = "SECRETARY_MESSAGE_GET_NOTE_SUCCESS",
  SECRETARY_MESSAGE_GET_NOTE_ERROR = "SECRETARY_MESSAGE_GET_NOTE_ERROR",

  GET_NUMBER_BY_REQUEST_ID_REQUEST = "GET_NUMBER_BY_REQUEST_ID_REQUEST",
  GET_NUMBER_BY_REQUEST_ID_SUCCESS = "GET_NUMBER_BY_REQUEST_ID_SUCCESS",
  GET_NUMBER_BY_REQUEST_ID_ERROR = "GET_NUMBER_BY_REQUEST_ID_ERROR",

  SET_RESET_SECRETARY_MESSAGE_PROPS = "SET_RESET_SECRETARY_MESSAGE_PROPS",

  INSERT_CUSTOMER_REQUEST = 'INSERT_CUSTOMER_REQUEST',
  INSERT_CUSTOMER_SUCCESS = 'INSERT_CUSTOMER_SUCCESS',
  INSERT_CUSTOMER_ERROR = 'INSERT_CUSTOMER_ERROR',

  DELETE_CUSTOMER_REQUEST = 'DELETE_CUSTOMER_REQUEST',
  DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS',
  DELETE_CUSTOMER_ERROR = 'DELETE_CUSTOMER_ERROR',

  UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST',
  UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS',
  UPDATE_CUSTOMER_ERROR = 'UPDATE_CUSTOMER_ERROR',

  RESET_CUSTOMER_LINE_ID_BY_CUSTOMER_ID_REQUEST = 'RESET_CUSTOMER_LINE_ID_BY_CUSTOMER_ID_REQUEST',
  RESET_CUSTOMER_INSERT_UPDATE = 'RESET_CUSTOMER_INSERT_UPDATE',


  CHANGE_MEMBER_NOTIFICATION_REQUEST = 'CHANGE_MEMBER_NOTIFICATION_REQUEST',
  CHANGE_MEMBER_NOTIFICATION_SUCCESS = 'CHANGE_MEMBER_NOTIFICATION_SUCCESS',
  CHANGE_MEMBER_NOTIFICATION_ERROR = 'CHANGE_MEMBER_NOTIFICATION_ERROR',


  SET_NEW_PASSWORD_REQUEST = 'SET_NEW_PASSWORD_REQUEST',
  SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS',
  SET_NEW_PASSWORD_ERROR = 'SET_NEW_PASSWORD_ERROR',

  SECRETARY_GET_CUSTOMER_LINES_REQUEST = 'SECRETARY_GET_CUSTOMER_LINES_REQUEST',
  SECRETARY_GET_CUSTOMER_LINES_SUCCESS = 'SECRETARY_GET_CUSTOMER_LINES_SUCCESS',
  SECRETARY_GET_CUSTOMER_LINES_ERROR = 'SECRETARY_GET_CUSTOMER_LINES_ERROR',

  GET_LINE_ID_BY_CUSTOMER_ID_REQUEST = ' GET_LINE_ID_BY_CUSTOMER_ID_REQUEST',
  GET_LINE_ID_BY_CUSTOMER_ID_SUCCESS = ' GET_LINE_ID_BY_CUSTOMER_ID_SUCCESS',
  GET_LINE_ID_BY_CUSTOMER_ID_ERROR = ' GET_LINE_ID_BY_CUSTOMER_ID_ERROR',

  GET_ACTIVE_QUEUE_REQUEST = 'GET_ACTIVE_QUEUE_REQUEST',
  GET_ACTIVE_QUEUE_SUCCESS = 'GET_ACTIVE_QUEUE_SUCCESS',
  GET_ACTIVE_QUEUE_ERROR = 'GET_ACTIVE_QUEUE_ERROR',

  RESET_INSERT_QUEUE = 'RESET_INSERT_QUEUE',
  RESET_UPDATE_QUEUE = 'RESET_UPDATE_QUEUE',
  RESET_UPSERT_QUEUE = 'RESET_UPSERT_QUEUE',

  RESET_ACTIVE_QUEUE = 'RESET_ACTIVE_QUEUE',
  RESET_DELETE_QUEUE = 'RESET_DELETE_QUEUE',

  GET_FAX_INBOX_REQUEST = ' GET_FAX_INBOX_REQUEST',
  GET_FAX_INBOX_SUCCESS = ' GET_FAX_INBOX_SUCCESS',
  GET_FAX_INBOX_ERROR = ' GET_FAX_INBOX_ERROR',

  GET_FAX_OUTBOX_REQUEST = ' GET_FAX_OUTBOX_REQUEST',
  GET_FAX_OUTBOX_SUCCESS = ' GET_FAX_OUTBOX_SUCCESS',
  GET_FAX_OUTBOX_ERROR = ' GET_FAX_OUTBOX_ERROR',

  SEND_NEW_FAX_REQUEST = ' SEND_NEW_FAX_REQUEST',
  SEND_NEW_FAX_SUCCESS = ' SEND_NEW_FAX_SUCCESS',
  SEND_NEW_FAX_ERROR = ' SEND_NEW_FAX_ERROR',


  GET_CUSTOMER_FAX_NUMBERS_REQUEST = ' GET_CUSTOMER_FAX_NUMBERS_REQUEST',
  GET_CUSTOMER_FAX_NUMBERS_SUCCESS = ' GET_CUSTOMER_FAX_NUMBERS_SUCCESS',
  GET_CUSTOMER_FAX_NUMBERS_ERROR = ' GET_CUSTOMER_FAX_NUMBERS_ERROR',


  GET_HAS_CUSTOMER_IVR_PRODUCT_REQUEST = ' GET_HAS_CUSTOMER_IVR_PRODUCT_REQUEST',
  GET_HAS_CUSTOMER_IVR_PRODUCT_SUCCESS = ' GET_HAS_CUSTOMER_IVR_PRODUCT_SUCCESS',
  GET_HAS_CUSTOMER_IVR_PRODUCT_ERROR = ' GET_HAS_CUSTOMER_IVR_PRODUCT_ERROR',


  GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_REQUEST = ' GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_REQUEST',
  GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_SUCCESS = ' GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_SUCCESS',
  GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_ERROR = ' GET_NATIONAL_CARD_CUSTOMER_DOCUMENT_STATUS_ERROR',


  GET_DOWNLOAD_OUTBOX_FILE_REQUEST = ' GET_DOWNLOAD_OUTBOX_FILE_REQUEST',
  GET_DOWNLOAD_OUTBOX_FILE_SUCCESS = ' GET_DOWNLOAD_OUTBOX_FILE_SUCCESS',
  GET_DOWNLOAD_OUTBOX_FILE_ERROR = ' GET_DOWNLOAD_OUTBOX_FILE_ERROR',

  GET_DOWNLOAD_INBOX_FILE_REQUEST = ' GET_DOWNLOAD_INBOX_FILE_REQUEST',
  GET_DOWNLOAD_INBOX_FILE_SUCCESS = ' GET_DOWNLOAD_INBOX_FILE_SUCCESS',
  GET_DOWNLOAD_INBOX_FILE_ERROR = ' GET_DOWNLOAD_INBOX_FILE_ERROR',

  GET_DELETE_INBOX_ITEM_REQUEST = ' GET_DELETE_INBOX_ITEM_REQUEST',
  GET_DELETE_INBOX_ITEM_SUCCESS = ' GET_DELETE_INBOX_ITEM_SUCCESS',
  GET_DELETE_INBOX_ITEM_ERROR = ' GET_DELETE_INBOX_ITEM_ERROR',

  RESET_FAX_PROPS = ' RESET_FAX_PROPS',

  GET_QUEUE_BY_CUSTOMER_ID_REQUEST = 'GET_QUEUE_BY_CUSTOMER_ID_REQUEST',
  GET_QUEUE_BY_CUSTOMER_ID_SUCCESS = 'GET_QUEUE_BY_CUSTOMER_ID_SUCCESS',
  GET_QUEUE_BY_CUSTOMER_ID_ERROR = 'GET_QUEUE_BY_CUSTOMER_ID_ERROR',




  GET_CALL_QUEUE_REPORT_REQUEST = 'GET_CALL_QUEUE_REPORT_REQUEST',
  GET_CALL_QUEUE_REPORT_ERROR = 'GET_CALL_QUEUE_REPORT_ERROR',
  GET_CALL_QUEUE_REPORT_SUCCESS = 'GET_CALL_QUEUE_REPORT_SUCCESS',

  GET_CALL_QUEUE_BY_RECORD_NAME_REQUEST = 'GET_CALL_QUEUE_BY_RECORD_NAME_REQUEST',
  GET_CALL_QUEUE_BY_RECORD_NAME_SUCCESS = 'GET_CALL_QUEUE_BY_RECORD_NAME_SUCCESS',
  GET_CALL_QUEUE_BY_RECORD_NAME_ERROR = 'GET_CALL_QUEUE_BY_RECORD_NAME_ERROR',


  RESET_DELETE_CUSTOMER_MEMBER_QUEUE = 'RESET_DELETE_CUSTOMER_MEMBER_QUEUE',
  RESET_CUSTOMER_DELETE = 'RESET_CUSTOMER_DELETE',

  RESET_GET_QUEUE_BY_CUSTOMER_ID = 'RESET_GET_QUEUE_BY_CUSTOMER_ID',
  RESET_GET_LINE_BY_CUSTOMER_ID = 'RESET_GET_LINE_BY_CUSTOMER_ID',


  GET_VOICE_MAIL_REQUEST = 'GET_VOICE_MAIL_REQUEST',
  GET_VOICE_MAIL_SUCCESS = 'GET_VOICE_MAIL_SUCCESS',
  GET_VOICE_MAIL_ERROR = 'GET_VOICE_MAIL_ERROR',



  SET_HEARD_BY_VOICE_EMAIL_ID_REQUEST = "SET_HEARD_BY_VOICE_EMAIL_ID_REQUEST",
  SET_HEARD_BY_VOICE_EMAIL_ID_SUCCESS = "SET_HEARD_BY_VOICE_EMAIL_ID_SUCCESS",
  SET_HEARD_BY_VOICE_EMAIL_ID_ERROR = "SET_HEARD_BY_VOICE_EMAIL_ID_ERROR",
  RESET_SET_HEARD_BY_VOICE_EMAIL_ID = "RESET_SET_HEARD_BY_VOICE_EMAIL_ID",

  MOVE_TO_TRASH_VOICE_EMAIL_REQUEST = "MOVE_TO_TRASH_VOICE_EMAIL_REQUEST",
  MOVE_TO_TRASH_VOICE_EMAIL_SUCCESS = "MOVE_TO_TRASH_VOICE_EMAIL_SUCCESS",
  MOVE_TO_TRASH_VOICE_EMAIL_ERROR = "MOVE_TO_TRASH_VOICE_EMAIL_ERROR",
  RESET_MOVE_TO_TRASH_VOICE_EMAIL = "RESET_MOVE_TO_TRASH_VOICE_EMAIL",

  GET_AUDIO_FILE_VOICE_MAIL_REQUEST = "GET_AUDIO_FILE_VOICE_MAIL_REQUEST",
  GET_AUDIO_FILE_VOICE_MAIL_SUCCESS = "GET_AUDIO_FILE_VOICE_MAIL_SUCCESS",
  GET_AUDIO_FILE_VOICE_MAIL_ERROR = "GET_AUDIO_FILE_VOICE_MAIL_ERROR",
  RESET_AUDIO_FILE_VOICE_MAIL = "RESET_AUDIO_FILE_VOICE_MAIL",




  GET_FREE_SECRETARY_PACKAGE_REQUEST = 'GET_FREE_SECRETARY_PACKAGE_REQUEST',
  GET_FREE_SECRETARY_PACKAGE_SUCCESS = 'GET_FREE_SECRETARY_PACKAGE_SUCCESS',
  GET_FREE_SECRETARY_PACKAGE_ERROR = 'GET_FREE_SECRETARY_PACKAGE_ERROR',


  GET_FREE_IVR_PACKAGE_REQUEST = 'GET_FREE_IVR_PACKAGE_REQUEST',
  GET_FREE_IVR_PACKAGE_SUCCESS = 'GET_FREE_IVR_PACKAGE_SUCCESS',
  GET_FREE_IVR_PACKAGE_ERROR = 'GET_FREE_IVR_PACKAGE_ERROR',

  RESET_FREE_SERVICE = 'RESET_FREE_SERVICE',


  GET_RESEND_FAX_REQUEST = 'GET_RESEND_FAX_REQUEST',
  GET_RESEND_FAX_SUCCESS = 'GET_RESEND_FAX_SUCCESS',
  GET_RESEND_FAX_ERROR = 'GET_RESEND_FAX_ERROR',


  GET_VOICE_MAIL_BOX_REQUEST = 'GET_VOICE_MAIL_BOX_REQUEST',
  GET_VOICE_MAIL_BOX_SUCCESS = 'GET_VOICE_MAIL_BOX_SUCCESS',
  GET_VOICE_MAIL_BOX_ERROR = 'GET_VOICE_MAIL_BOX_ERROR',


  ///-----------------------------------------------------------------


  GET_ALL_CONTACTS_REQUEST = 'GET_ALL_CONTACTS_REQUEST',
  GET_ALL_CONTACTS_SUCCESS = 'GET_ALL_CONTACTS_SUCCESS',
  GET_ALL_CONTACTS_ERROR = 'GET_ALL_CONTACTS_ERROR',


  GET_CONTACTS_BY_PHONE_BOOK_ID_REQUEST = 'GET_CONTACTS_BY_PHONE_BOOK_ID_REQUEST',
  GET_CONTACTS_BY_PHONE_BOOK_ID_SUCCESS = 'GET_CONTACTS_BY_PHONE_BOOK_ID_SUCCESS',
  GET_CONTACTS_BY_PHONE_BOOK_ID_ERROR = 'GET_CONTACTS_BY_PHONE_BOOK_ID_ERROR',


  ADD_CONTACT_REQUEST = 'ADD_CONTACT_REQUEST',
  ADD_CONTACT_SUCCESS = 'ADD_CONTACT_SUCCESS',
  ADD_CONTACT_ERROR = 'ADD_CONTACT_ERROR',


  UPDATE_CONTACT_REQUEST = 'UPDATE_CONTACT_REQUEST',
  UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS',
  UPDATE_CONTACT_ERROR = 'UPDATE_CONTACT_ERROR',


  REMOVE_FROM_PHONE_BOOK_CONTACT_REQUEST = 'REMOVE_FROM_PHONE_BOOK_CONTACT_REQUEST',
  REMOVE_FROM_PHONE_BOOK_CONTACT_SUCCESS = 'REMOVE_FROM_PHONE_BOOK_CONTACT_SUCCESS',
  REMOVE_FROM_PHONE_BOOK_CONTACT_ERROR = 'REMOVE_FROM_PHONE_BOOK_CONTACT_ERROR',


  REMOVE_CONTACT_REQUEST = 'REMOVE_CONTACT_REQUEST',
  REMOVE_CONTACT_SUCCESS = 'REMOVE_CONTACT_SUCCESS',
  REMOVE_CONTACT_ERROR = 'REMOVE_CONTACT_ERROR',


  ADD_CONTACT_CATEGORY_REQUEST = 'ADD_CONTACT_CATEGORY_REQUEST',
  ADD_CONTACT_CATEGORY_SUCCESS = 'ADD_CONTACT_CATEGORY_SUCCESS',
  ADD_CONTACT_CATEGORY_ERROR = 'ADD_CONTACT_CATEGORY_ERROR',


  UPDATE_CONTACT_CATEGORY_REQUEST = 'UPDATE_CONTACT_CATEGORY_REQUEST',
  UPDATE_CONTACT_CATEGORY_SUCCESS = 'UPDATE_CONTACT_CATEGORY_SUCCESS',
  UPDATE_CONTACT_CATEGORY_ERROR = 'UPDATE_CONTACT_CATEGORY_ERROR',


  REMOVE_CONTACT_CATEGORY_REQUEST = 'REMOVE_CONTACT_CATEGORY_REQUEST',
  REMOVE_CONTACT_CATEGORY_SUCCESS = 'REMOVE_CONTACT_CATEGORY_SUCCESS',
  REMOVE_CONTACT_CATEGORY_ERROR = 'REMOVE_CONTACT_CATEGORY_ERROR',

  GET_CONTACT_CATEGORY_REQUEST = 'GET_CONTACT_CATEGORY_REQUEST',
  GET_CONTACT_CATEGORY_SUCCESS = 'GET_CONTACT_CATEGORY_SUCCESS',
  GET_CONTACT_CATEGORY_ERROR = 'GET_CONTACT_CATEGORY_ERROR',

  GET_PHONE_BOOKS_REQUEST = 'GET_PHONE_BOOKS_REQUEST',
  GET_PHONE_BOOKS_SUCCESS = 'GET_PHONE_BOOKS_SUCCESS',
  GET_PHONE_BOOKS_ERROR = 'GET_PHONE_BOOKS_ERROR',


  GET_PHONEBOOK_UNPAGED_REQUEST = 'GET_PHONEBOOK_UNPAGED_REQUEST',
  GET_PHONEBOOK_UNPAGED_SUCCESS = 'GET_PHONEBOOK_UNPAGED_SUCCESS',
  GET_PHONEBOOK_UNPAGED_ERROR = 'GET_PHONEBOOK_UNPAGED_ERROR',

  ADD_PHONE_BOOK_REQUEST = 'ADD_PHONE_BOOK_REQUEST',
  ADD_PHONE_BOOK_SUCCESS = 'ADD_PHONE_BOOK_SUCCESS',
  ADD_PHONE_BOOK_ERROR = 'ADD_PHONE_BOOK_ERROR',

  UPDATE_PHONE_BOOK_REQUEST = 'UPDATE_PHONE_BOOK_REQUEST',
  UPDATE_PHONE_BOOK_SUCCESS = 'UPDATE_PHONE_BOOK_SUCCESS',
  UPDATE_PHONE_BOOK_ERROR = 'UPDATE_PHONE_BOOK_ERROR',

  DELETE_PHONE_BOOK_REQUEST = 'DELETE_PHONE_BOOK_REQUEST',
  DELETE_PHONE_BOOK_SUCCESS = 'DELETE_PHONE_BOOK_SUCCESS',
  DELETE_PHONE_BOOK_ERROR = 'DELETE_PHONE_BOOK_ERROR',

  COPY_BY_PHONEBOOK_REQUEST = 'COPY_BY_PHONEBOOK_REQUEST',
  COPY_BY_PHONEBOOK_SUCCESS = 'COPY_BY_PHONEBOOK_SUCCESS',
  COPY_BY_PHONEBOOK_ERROR = 'COPY_BY_PHONEBOOK_ERROR',

  MOVE_BY_PHONEBOOK_REQUEST = 'MOVE_BY_PHONEBOOK_REQUEST',
  MOVE_BY_PHONEBOOK_SUCCESS = 'MOVE_BY_PHONEBOOK_SUCCESS',
  MOVE_BY_PHONEBOOK_ERROR = 'MOVE_BY_PHONEBOOK_ERROR',



  COPY_BY_CONTACT_REQUEST = 'COPY_BY_CONTACT_REQUEST',
  COPY_BY_CONTACT_SUCCESS = 'COPY_BY_CONTACT_SUCCESS',
  COPY_BY_CONTACT_ERROR = 'COPY_BY_CONTACT_ERROR',

  MOVE_BY_CONTACT_REQUEST = 'MOVE_BY_CONTACT_REQUEST',
  MOVE_BY_CONTACT_SUCCESS = 'MOVE_BY_CONTACT_SUCCESS',
  MOVE_BY_CONTACT_ERROR = 'MOVE_BY_CONTACT_ERROR',



  CONTACT_LIST_TO_BLOCK_REQUEST = 'CONTACT_LIST_TO_BLOCK_REQUEST',
  CONTACT_LIST_TO_BLOCK_SUCCESS = 'CONTACT_LIST_TO_BLOCK_SUCCESS',
  CONTACT_LIST_TO_BLOCK_ERROR = 'CONTACT_LIST_TO_BLOCK_ERROR',



  GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST',
  GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS',
  GET_CONTACT_ERROR = 'GET_CONTACT_ERROR',


  GET_UNPAGED_CONTACT_REQUEST = 'GET_UNPAGED_CONTACT_REQUEST',
  GET_UNPAGED_CONTACT_SUCCESS = 'GET_UNPAGED_CONTACT_SUCCESS',
  GET_UNPAGED_CONTACT_ERROR = 'GET_UNPAGED_CONTACT_ERROR',
  // PHONEBOOK_LIST_TO_DELETE_REQUEST = 'PHONEBOOK_LIST_TO_DELETE_REQUEST',
  // PHONEBOOK_LIST_TO_DELETE_SUCCESS = 'PHONEBOOK_LIST_TO_DELETE_SUCCESS',
  // PHONEBOOK_LIST_TO_DELETE_ERROR = 'PHONEBOOK_LIST_TO_DELETE_ERROR',


  RESET_CONTACT_PROPS = 'RESET_CONTACT_PROPS',

  GET_CUSTOMER_ACTIVE_FAX_NUMBER_REQUEST = 'GET_CUSTOMER_ACTIVE_FAX_NUMBER_REQUEST',
  GET_CUSTOMER_ACTIVE_FAX_NUMBER_SUCCESS = 'GET_CUSTOMER_ACTIVE_FAX_NUMBER_SUCCESS',
  GET_CUSTOMER_ACTIVE_FAX_NUMBER_ERROR = 'GET_CUSTOMER_ACTIVE_FAX_NUMBER_ERROR',
  OPERATION_LOGS_PUSH = 'OPERATION_LOGS_PUSH',
  GET_OPERATION_LOGS = 'GET_OPERATION_LOGS',

  SET_SELECTED_CONTACT_CATEGORY = 'SET_SELECTED_CONTACT_CATEGORY',
  GET_SELECTED_CONTACT_CATEGORY = 'GET_SELECTED_CONTACT_CATEGORY',



  ADD_HOLIDAY_REQUEST = 'ADD_HOLIDAY_REQUEST',
  ADD_HOLIDAY_SUCCESS = 'ADD_HOLIDAY_SUCCESS',
  ADD_HOLIDAY_ERROR = 'ADD_HOLIDAY_ERROR',


  UPDATE_HOLIDAY_REQUEST = 'UPDATE_HOLIDAY_REQUEST',
  UPDATE_HOLIDAY_SUCCESS = 'UPDATE_HOLIDAY_SUCCESS',
  UPDATE_HOLIDAY_ERROR = 'UPDATE_HOLIDAY_ERROR',


  REMOVE_HOLIDAY_REQUEST = 'REMOVE_HOLIDAY_REQUEST',
  REMOVE_HOLIDAY_SUCCESS = 'REMOVE_HOLIDAY_SUCCESS',
  REMOVE_HOLIDAY_ERROR = 'REMOVE_HOLIDAY_ERROR',

  GET_HOLIDAY_REQUEST = 'GET_HOLIDAY_REQUEST',
  GET_HOLIDAY_SUCCESS = 'GET_HOLIDAY_SUCCESS',
  GET_HOLIDAY_ERROR = 'GET_HOLIDAY_ERROR',

  RESET_HOLIDAY_PROPS = 'RESET_HOLIDAY_PROPS',
  GET_LINE_VOICE_MAIL_URL_REQUEST = "GET_LINE_VOICE_MAIL_URL_REQUEST",
  GET_LINE_VOICE_MAIL_URL_SUCCESS = "GET_LINE_VOICE_MAIL_URL_SUCCESS",
  GET_LINE_VOICE_MAIL_URL_ERROR = "GET_LINE_VOICE_MAIL_URL_ERROR",


  POST_LINE_VOICE_MAIL_URL_REQUEST = "POST_LINE_VOICE_MAIL_URL_REQUEST",
  POST_LINE_VOICE_MAIL_URL_SUCCESS = "POST_LINE_VOICE_MAIL_URL_SUCCESS",
  POST_LINE_VOICE_MAIL_URL_ERROR = "POST_LINE_VOICE_MAIL_URL_ERROR",

  GET_LATEST_CALLS_REQUEST = "GET_LATEST_CALLS_REQUEST",
  GET_LATEST_CALLS_SUCCESS = "GET_LATEST_CALLS_SUCCESS",
  GET_LATEST_CALLS_ERROR = "GET_LATEST_CALLS_ERROR",

  RESET_DASHBOARD_PROPS_REQUEST = "RESET_DASHBOARD_PROPS_REQUEST",

  GET_REPORT_CALL_QUEUE_BY_DATE_REQUEST = "GET_REPORT_CALL_QUEUE_BY_DATE_REQUEST",
  GET_REPORT_CALL_QUEUE_BY_DATE_SUCCESS = "GET_REPORT_CALL_QUEUE_BY_DATE_SUCCESS",
  GET_REPORT_CALL_QUEUE_BY_DATE_ERROR = "GET_REPORT_CALL_QUEUE_BY_DATE_ERROR",


  GET_REPORT_ACTIVITY_CALL_QUEUE_REQUEST = "GET_REPORT_ACTIVITY_CALL_QUEUE_REQUEST",
  GET_REPORT_ACTIVITY_CALL_QUEUE_SUCCESS = "GET_REPORT_ACTIVITY_CALL_QUEUE_SUCCESS",
  GET_REPORT_ACTIVITY_CALL_QUEUE_ERROR = "GET_REPORT_ACTIVITY_CALL_QUEUE_ERROR",


  GET_WEEKLY_REPORT_CALL_QUEUE_REQUEST = "GET_WEEKLY_REPORT_CALL_QUEUE_REQUEST",
  GET_WEEKLY_REPORT_CALL_QUEUE_SUCCESS = "GET_WEEKLY_REPORT_CALL_QUEUE_SUCCESS",
  GET_WEEKLY_REPORT_CALL_QUEUE_ERROR = "GET_WEEKLY_REPORT_CALL_QUEUE_ERROR",

  GET_IS_FREE_PRODUCT_REQUEST = "GET_IS_FREE_PRODUCT_REQUEST",
  GET_IS_FREE_PRODUCT_SUCCESS = "GET_IS_FREE_PRODUCT_SUCCESS",
  GET_IS_FREE_PRODUCT_ERROR = "GET_IS_FREE_PRODUCT_ERROR",


  GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_REQUEST = "GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_REQUEST",
  GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_SUCCESS = "GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_SUCCESS",
  GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_ERROR = "GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_ERROR",

  CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_REQUEST = "CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_REQUEST",
  CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_SUCCESS = "CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_SUCCESS",
  CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_ERROR = "CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_ERROR",

  RESET_PURCHASE_CREATE_INVOICE_PROPS = "RESET_PURCHASE_CREATE_INVOICE_PROPS",
  OUGOING_CALL_REQUEST = "OUGOING_CALL_REQUEST",
  OUGOING_CALL_SUCCESS = "OUGOING_CALL_SUCCESS",
  OUGOING_CALL_ERROR = "OUGOING_CALL_ERROR",
  RESET_OUTGOING_CALL = "RESET_OUTGOING_CALL",

  GET_CALL_RATING_REQUEST = "GET_CALL_RATING_REQUEST",
  GET_CALL_RATING_SUCCSEE = "GET_CALL_RATING_SUCCSEE",
  GET_CALL_RATING_ERROR = "GET_CALL_RATING_ERROR",
  GET_CALL_RATING_RESET = "GET_CALL_RATING_RESET",

  SET_CALL_RATING_REQUEST = "SET_CALL_RATING_REQUEST",
  SET_CALL_RATING_SUCCSEE = "SET_CALL_RATING_SUCCSEE",
  SET_CALL_RATING_ERROR = "SET_CALL_RATING_ERROR",



  RESET_INVOICE = "RESET_INVOICE",

  GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_REQUEST = "GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_REQUEST",
  GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_SUCCESS = "GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_SUCCESS",
  GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_ERROR = "GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_ERROR",

  GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_REQUEST = "GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_REQUEST",
  GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_SUCCESS = "GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_SUCCESS",
  GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_ERROR = "GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_ERROR",

  RESET_SAVE_NOTE_PROPS = "RESET_SAVE_NOTE_PROPS",

  GET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST="GET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST",
  GET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS="GET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS",
  GET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR="GET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR",

  SET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST="SET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST",
  SET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS="SET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS",
  SET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR="SET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR",

  RESET_OUT_GOING_ON_SECRETARY_SETTINGS="RESET_OUT_GOING_ON_SECRETARY_SETTINGS",

}
